import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import {
  MotifIconModule,
  MotifModalModule,
  ButtonSizes,
  MotifButtonModule,
  MotifTooltipModule,
  MotifModalRef,
} from '@ey-xd/ng-motif';
import { IconoirXmark, IconoirPrivacyPolicy } from '@ey-xd/motif-icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CommonService } from '@services/common.service';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy-component',
  imports: [
    MotifModalModule,
    MotifIconModule,
    MotifButtonModule,
    MotifTooltipModule,
    CommonModule,
    TranslatePipe,
    TranslateDirective,
  ],
  templateUrl: './privacy-component.component.html',
  styleUrl: './privacy-component.component.scss',
})
export class PrivacyComponentComponent implements AfterViewInit, OnDestroy {
  closeIcon = IconoirXmark;
  privacyPolicyIcon = IconoirPrivacyPolicy;
  buttonSizes = ButtonSizes;
  @ViewChild('modalContent') modalContent!: ElementRef;
  @ViewChild('listItem') listItem!: ElementRef;
  isVisible: any;
  acceptDisabled: any = true;
  //private scrollListener!: () => void; // Reference to the scroll listener

  constructor(
    private readonly route: Router,
    public commonService: CommonService,
    private readonly dialogRef: MotifModalRef<PrivacyComponentComponent>,
  ) {
    this.isVisible = localStorage.getItem('privacyNotice');
    if (this.isVisible === 'false') {
      this.isVisible = false;
    }
    if (this.isVisible === 'true') {
      this.isVisible = true;
    }
  }
  ngOnDestroy(): void {
    // Remove the scroll event listener to prevent memory leaks
    // if (this.scrollListener) {
    //   this.modalContent.nativeElement.removeEventListener('scroll', this.scrollListener);
    // }
    localStorage.setItem('privacyNotice', 'false');
  }
  ngAfterViewInit(): void {
    // this.scrollListener = () => this.onScroll();
    // this.modalContent.nativeElement.addEventListener('scroll', this.scrollListener);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.acceptDisabled = false;
            observer.disconnect(); // Stop observing after the alert
          }
        });
      },
      { threshold: 1.0 }, // Fully visible
    );

    observer.observe(this.listItem.nativeElement);
  }

  onDecline() {
    // this.commonService.isLoading.next(true);
    this.commonService.stopWatching();
    this.commonService.clearStorage();
    this.route.navigateByUrl('/logout');
    // this.commonService.isLoading.next(false);
    localStorage.setItem('privacyNotice', 'false');
    this.dialogRef.close({ response: false });
  }
  onAccept() {
    localStorage.setItem('privacyNotice', 'false');
    this.dialogRef.close({ response: true });
  }

  // onScroll(): void {
  //   const popupElement = this.modalContent.nativeElement;
  //   if (Math.abs(popupElement.scrollHeight - popupElement.scrollTop - popupElement.clientHeight) < 1) {
  //     this.acceptDisabled = false;
  //   }
  // }

  closePrivacyPopup() {
    localStorage.setItem('privacyNotice', 'false');
  }
}
